import store$ from './store'
import { render$ } from './view'
import { Observable } from '@reactivex/rxjs'

store$.subscribe(render$)



// WEBPACK FOOTER //
// ./index.js